(function ($) {
    function initPressPage() {
        $('.section-press-awards .read-more-wrap a').on('click', function (e) {
            e.preventDefault();
            $('.section-press-awards').addClass('is-opened');
        });
    }

    function initPrivacyHubPage() {
        if(window.innerWidth >= 1024) {
            jQuery('.data-section .box').stickyScrollBlock({
                setBoxHeight: true,
                activeClass: 'fixed-position',
                container: '.data-section .container',
                positionType: 'fixed',
                extraTop: 10
            });
        } else {
            jQuery('.data-section .box').stickyScrollBlock('destroy');
        }

        $('.box-holder').clone().insertAfter($('section').find('.intro'));

        $('.no-link a').hasClass('active') ? $('.foot').addClass('active') : $('.foot').removeClass('active');
        $('.data-section li:not(.no-link) a').click(function() {
            $('.foot').removeClass('active');

            $($(this).attr('href')).siblings().removeClass('active').addClass('js-tab-hidden');

            var target = jQuery(this.hash),
                headerHeight = $('.header-rebranded').outerHeight();
            setTimeout(function() {
                jQuery('html, body').animate({
                    scrollTop: target.offset().top - (headerHeight + 50)
                }, 500);
            }, 80);

            setTimeout(function() {
                jQuery('.data-section .box').stickyScrollBlock('attachEvents');
            }, 180);
        })

        $('.data-section .box').tabset({
            tabLinks: 'a',
            defaultTab: true
        });
    }

    jQuery(window).on('load', function($){

    });

    jQuery(document).ready(function($){
        // initPressPage();
        initPrivacyHubPage();
    });

})(jQuery);